<template>
<div></div>
</template>



<script>
import Split from 'split.js'

  export default {
    data: () => ({
        splitinstance: undefined
    }),
    mounted() {
        this.splitinstance = Split(['#data_sidebar','#data_grid'],{
            sizes: [40, 60],
            gutterSize: 5,
            gutterAlign: 'center'
        })

        
    },
    beforeDestroy(){
        this.splitinstance.destroy()
    }
  }
</script>

<style>
.gutter{
  cursor: col-resize;
  background-color:#dfdfdf;
  -webkit-box-shadow: 2px 0px 2px 0px rgba(0,0,0,0.25);
-moz-box-shadow: 2px 0px 2px 0px rgba(0,0,0,0.25);
box-shadow: 2px 0px 2px 0px rgba(0,0,0,0.25);
z-index:2;
}
</style>